import { init as initIssues } from './issues';

import { serveChannelRequests } from 'serviceWorker/channelServers';
import { init as initDbChangesListener } from 'serviceWorker/services/dbChangeListener';
import { init as initCurrentUserIdentity, restoreCurrentUserIdentity } from './currentUser/identity';
import { init as initDataClearer } from './dataClearer';
import { init as initDocuments } from './documents';
import { init as initHttpQueue } from './httpQueue';
import { init as initIssueForm } from './issueForm';
import { init as initLogout } from './logout';
import { init as initPermissions } from './permissions';
import { init as initProcesses } from './processes';
import { init as initProjectData } from './projectData';
import { init as initReports } from './reports';
import { init as initSelectedProject } from './selectedProject';

import { InitAll } from './factories/types';
import { markServicesReady } from './servicesReady';
import { repairCollectionsAtStart } from 'serviceWorker/db/flush';
import { init as initDataScope } from 'serviceWorker/helpers/dataScope';
import { swLog } from 'serviceWorker/helpers/makeSwLogger';
import { LogLevel } from 'shared/types/logger';

export const initAllServices: InitAll = () => {
  // First: operations started from here on know when their data becomes outdated.
  initDataScope();
  // Listening from the first moment: a request sent while the worker starts (also after the
  // browser stopped it) is not lost; its handler waits for `markServicesReady` (PT-7258).
  serveChannelRequests();
  // Before the services start: no download may run on a collection that is being cleared.
  // The user is restored first: the repair logs before the page can announce them (PT-7276).
  void restoreCurrentUserIdentity()
    .then(repairCollectionsAtStart)
    .catch((error: unknown) => swLog('Could not repair the stored collections', LogLevel.ERROR, error, null))
    .then(() => {
      [
        initCurrentUserIdentity,
        initDataClearer,
        initDocuments,
        initIssueForm,
        initIssues,
        initLogout,
        initPermissions,
        initProcesses,
        initProjectData,
        initReports,
        initSelectedProject,
        initDbChangesListener,
        initHttpQueue,
      ].forEach((init) => {
        init();
      });
    })
    .finally(markServicesReady);
};
